import { UserRoles } from "./UserRoles";

export const HeaderTabs = [
  {
    label: "Content App",
    href: "/mediaRequest",
    id: "mediaRequest",
    permittedRoles: [
      UserRoles.MEDIAREQUEST,
      UserRoles.SUPERADMIN,
      UserRoles.GLOBALADMIN,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
    ],
  },
  {
    label: "Legacy GMSC",
    href: "/legacyGmsc",
    id: "contentFinder",
    permittedRoles: [
      UserRoles.LEGACY_GMSC,
      UserRoles.GLOBALADMIN
    ],
  },
  {
    label: "New Request",
    href: "/request",
    id: "new",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Job Dashboard",
    href: "/",
    id: "job",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
      UserRoles.CR_API,
      UserRoles.ADMINWITHREADACCESS,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Request Dashboard",
    href: "/",
    id: "request",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
      UserRoles.CR_API,
      UserRoles.ADMINWITHREADACCESS,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Media Request Dashboard",
    href: "/",
    id: "request",
    permittedRoles: [UserRoles.MEDIAREQUEST],
  },
  {
    label: "Help",
    href: "https://warnermedia.sharepoint.com/sites/MPO/StudioOperations/MORPhHELP/SitePages/Welcome.aspx",
    id: "help",
    target: true,
    rel: true,
    permittedRoles: [
      UserRoles.MEDIAREQUEST,
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
      UserRoles.ADMINWITHREADACCESS,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Okta Admin Page",
    //   href: config[0].oidc.adminOktaPage,
    id: "okta",
    target: true,
    rel: true,
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "User Management",
    href: "/users",
    id: "user",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Delivery Management",
    href: "/lists",
    id: "delivery",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.GLOBALADMIN,
    ],
  },
  {
    label: "Logout",
    href: "/logout",
    id: "logout",
    permittedRoles: [
      UserRoles.SUPERADMIN,
      UserRoles.ADMIN,
      UserRoles.ADMINWITHREADACCESS,
      UserRoles.CR_API,
      UserRoles.MEDIAREQUEST,
      UserRoles.OPS,
      UserRoles.REQUESTOR,
      UserRoles.GLOBALADMIN,
      UserRoles.LEGACY_GMSC,
    ],
  },
];
